import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'warningMessage', 'form']

  hasBeenChanged = false
  
  updateInput() {
    this.hasBeenChanged = true
  }

  submit(e) {
    e.preventDefault()
    if (this.hasBeenChanged) {
        if (!confirm(this.warningMessageTarget.innerText)) {
          e.preventDefault()
        } else {
            this.formTarget.submit()
        }
    } else {
        this.formTarget.submit()
    }
  }
}